import "./Breadcrumb.scss";
import clsx from "clsx";
import { ComponentType } from "react";

export type BreadcrumbItemProps = {
  label: string;
  href?: string;
  isClickable?: boolean;
  asLink?: "a" | ComponentType<any>;
};

export const BreadcrumbItem = ({
  label,
  href,
  isClickable,
  asLink = "a",
}: BreadcrumbItemProps) => {
  const LinkComponent = asLink;
  return (
    <span
      className={clsx("ui-breadcrumb-item", {
        "active text-slate-20 fw-semibold": isClickable,
        "text-slate-28": !isClickable,
      })}
    >
      {href && isClickable ? (
        <LinkComponent href={href}>{label}</LinkComponent>
      ) : (
        label
      )}
    </span>
  );
};
